import { useMutation } from '@tanstack/react-query';
import { useToast } from '@/contexts/ToastContext';
import { driverApi } from '@/services/driverApi';
import { CapturedPhoto } from '@/types/document';

export interface CapturedPhotoRequest {
  dataUrl: string;
  latitude: number;
  longitude: number;
  captureTime: string;
  documentType: string;
  name?: string;
  notes?: string;
}

export interface InspectionReportRequest {
  inspectionType: 'ON_SITE' | 'ON_DROP_OFF';
  vehicleDamaged: boolean;
  latitude?: number;
  longitude?: number;
  notes?: string;
  photos: CapturedPhotoRequest[];
  documentIds?: string[];
}

export interface InspectionReportResponse {
  id: string;
  dispatchId: string;
  inspectionType: string;
  vehicleDamaged: boolean;
  takenBy: string;
  notes?: string;
  documentIds: string[];
  mediaUrls?: string[];
  urgentlyReportId?: string;
  urgentlyStatus?: string;
  submittedAt?: string;
  createdAt: string;
}

/**
 * Hook to submit an inspection report to Urgently
 */
export function useSubmitInspectionReport() {
  const { showToast } = useToast();

  return useMutation({
    mutationFn: async ({
      dispatchId,
      data,
    }: {
      dispatchId: string;
      data: InspectionReportRequest;
    }) => {
      const response = await driverApi.submitInspectionReport(dispatchId, data);
      return response.data;
    },
    onSuccess: (result, variables) => {
      showToast('success', 'Inspection report submitted successfully', 3000);
    },
    onError: (error: any) => {
      const message = error.message || 'Failed to submit inspection report';
      showToast('error', message, 3000);
    },
  });
}
